import { type FC, memo, useState, type ChangeEventHandler } from 'react';
import styles from './index.module.scss';
import { useModel } from 'foca';
import { globalSettingModel } from '@models/global-setting.model';
import Input from '@ui/input';
import slippageIcon from '@assets/images/parrot/slippage.svg';
import closeIcon from '@assets/images/parrot/close.svg';
import Popover from '@ui/parrot/popover';
const SelectSlippage: FC = () => {
  const [showSetting, setShowSetting] = useState(false);
  const { slippage } = useModel(globalSettingModel);
  return (
    <Popover
      content={<Setting changeSetting={setShowSetting} />}
      trigger={'click'}
      open={showSetting}
      onOpenChange={setShowSetting}
    >
      <div
        className={styles.button}
        onClick={() => {
          setShowSetting(true);
        }}
      >
        <img src={slippageIcon} data-icon />
        <span>{slippage}%</span>
      </div>
    </Popover>
  );
};

const Setting: FC<{ changeSetting(value: boolean): void }> = ({ changeSetting }) => {
  const { slippage } = useModel(globalSettingModel);
  const [inputValue, setInputValue] = useState(slippage);

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = Number(e.target.value) >= 0 ? e.target.value : '0.1';
    setInputValue(value);
  };

  const save = () => {
    globalSettingModel.setEnumSlippage(Number(inputValue).toString());
    changeSetting(false);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.setting_title}>
        <span>Setting</span>
        <img src={closeIcon} onClick={() => changeSetting(false)} />
      </div>
      <div className={styles.setting_text}>Set your slippage tolerance for swap transactions.</div>
      <div className={styles.setting}>
        <div className={styles.custom}>
          {['0.1', '0.5', '1', '2'].map((item) => (
            <span
              key={item}
              className={item === inputValue ? styles.selected : ''}
              onClick={() => setInputValue(item)}
            >
              {item}
              {Number.isFinite(Number(item)) && '%'}
            </span>
          ))}
        </div>
        <Input
          wrapperClassName={styles.input_wrapper}
          focusClassName={styles.input_focus}
          type="text"
          value={inputValue}
          placeholder="0.1"
          onChange={handleChange}
          suffix="%"
        />
      </div>
      <div className={styles.btn} onClick={save}>
        save
      </div>
    </div>
  );
};

export default memo(SelectSlippage);
